export default __webpack_public_path__ + "static/1-0cf3345294837c011ab896f81835103b.jpg";